import RulesRouting from './components/Router'

import './styles.scss'

export {
  RulesRouting
}
